export const GAME104DAY2VOTES = [
  {
    postId: 223,
    timestamp: '2022-07-22T11:46:00.000Z',
    players: {
      'Asako': [],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [],
      'GB': [],
      'Gnut': [],
      'SirSam': [],
      'James': [],
      'Brandish': [],
      'Pom': [],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}],
    }
  },
  {
    postId: 229,
    timestamp: '2022-07-22T11:57:00.000Z',
    players: {
      'Asako': [],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}],
      'GB': [],
      'Gnut': [],
      'SirSam': [],
      'James': [],
      'Brandish': [],
      'Pom': [],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}],
    }
  },
  {
    postId: 231,
    timestamp: '2022-07-22T00:06:00.000Z',
    players: {
      'Asako': [],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}],
      'GB': [],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}],
      'James': [],
      'Brandish': [],
      'Pom': [],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}],
    }
  },
  {
    postId: 234,
    timestamp: '2022-07-22T00:12:00.000Z',
    players: {
      'Asako': [],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}],
      'GB': [],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}],
    }
  },
  {
    postId: 252,
    timestamp: '2022-07-22T00:40:00.000Z',
    players: {
      'Asako': [],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}],
    }
  },
  {
    postId: 288,
    timestamp: '2022-07-22T18:04:00.000Z',
    players: {
      'Asako': [],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}],
    }
  },
  {
    postId: 289,
    timestamp: '2022-07-22T18:08:00.000Z',
    players: {
      'Asako': [],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}, {player: 'SirSam', lock: false}],
    }
  },
  {
    postId: 291,
    timestamp: '2022-07-22T18:14:00.000Z',
    players: {
      'Asako': [],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [{player: 'Pom', lock: false}],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}, {player: 'SirSam', lock: false}],
    }
  },
  {
    postId: 344,
    timestamp: '2022-07-22T21:26:00.000Z',
    players: {
      'Asako': [],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [{player: 'Pom', lock: false}],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}, {player: 'Asako', lock: false}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}, {player: 'SirSam', lock: false}],
    }
  },
  {
    postId: 344,
    timestamp: '2022-07-22T21:26:00.000Z',
    players: {
      'Asako': [],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [{player: 'Pom', lock: false}],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}, {player: 'Asako', lock: false}, {player: 'Anonymous vote', lock: true}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}, {player: 'SirSam', lock: false}],
    }
  },
  {
    postId: 351,
    timestamp: '2022-07-22T21:32:00.000Z',
    players: {
      'Asako': [],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [{player: 'Pom', lock: false}],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}, {player: 'Asako', lock: false}, {player: 'Anonymous vote', lock: true}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}, {player: 'Tatsumaki', lock: false}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}, {player: 'SirSam', lock: false}],
    }
  },
  {
    postId: 355,
    timestamp: '2022-07-22T21:39:00.000Z',
    players: {
      'Asako': [],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [{player: 'Pom', lock: false}],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}, {player: 'Asako', lock: false}, {player: 'Anonymous vote', lock: true}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}, {player: 'Tatsumaki', lock: false}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}, {player: 'SirSam', lock: false}, {player: 'James', lock: true}],
    }
  },
  {
    postId: 377,
    timestamp: '2022-07-22T22:14:00.000Z',
    players: {
      'Asako': [{player: 'Gnut', lock: false}],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [{player: 'Pom', lock: false}],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}, {player: 'Asako', lock: false}, {player: 'Anonymous vote', lock: true}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}, {player: 'Tatsumaki', lock: false}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}, {player: 'SirSam', lock: false}, {player: 'James', lock: true}],
    }
  },
  {
    postId: 391,
    timestamp: '2022-07-22T22:37:00.000Z',
    players: {
      'Asako': [{player: 'Gnut', lock: false}, {player: 'Maryxxi', lock: false}],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [{player: 'Pom', lock: false}],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}, {player: 'Asako', lock: false}, {player: 'Anonymous vote', lock: true}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}, {player: 'Tatsumaki', lock: false}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}, {player: 'SirSam', lock: false}, {player: 'James', lock: true}],
    }
  },
  {
    postId: 402,
    timestamp: '2022-07-22T22:37:00.000Z',
    players: {
      'Asako': [{player: 'Gnut', lock: false}, {player: 'Maryxxi', lock: false}],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [{player: 'Pom', lock: false}],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}, {player: 'Asako', lock: false}, {player: 'Anonymous vote', lock: true}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}, {player: 'Tatsumaki', lock: false}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}, {player: 'SirSam', lock: false}, {player: 'James', lock: true}, {player: 'Demonspeed', lock: true}],
    }
  },
  {
    postId: 405,
    timestamp: '2022-07-22T22:57:00.000Z',
    players: {
      'Asako': [{player: 'Gnut', lock: false}, {player: 'Maryxxi', lock: false}],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [{player: 'Pom', lock: false}],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}, {player: 'Asako', lock: false}, {player: 'Anonymous vote', lock: true}, {player: 'Hermit', lock: true}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}, {player: 'Tatsumaki', lock: false}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}, {player: 'SirSam', lock: false}, {player: 'James', lock: true}, {player: 'Demonspeed', lock: true}],
    }
  },
  {
    postId: 410,
    timestamp: '2022-07-22T23:09:00.000Z',
    players: {
      'Asako': [{player: 'Gnut', lock: false}, {player: 'Maryxxi', lock: false}],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [{player: 'Pom', lock: false}],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}, {player: 'Asako', lock: false}, {player: 'Anonymous vote', lock: true}, {player: 'Hermit', lock: true}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}, {player: 'Tatsumaki', lock: false}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}, {player: 'SirSam', lock: false}, {player: 'James', lock: true}, {player: 'Demonspeed', lock: true}, {player: 'Shad', lock: true}],
    }
  },
  {
    postId: 412,
    timestamp: '2022-07-22T23:11:00.000Z',
    players: {
      'Asako': [{player: 'Gnut', lock: false}, {player: 'Maryxxi', lock: false}],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [{player: 'Pom', lock: false}],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}, {player: 'Asako', lock: false}, {player: 'Anonymous vote', lock: true}, {player: 'Hermit', lock: true}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}, {player: 'Tatsumaki', lock: false}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}, {player: 'SirSam', lock: false}, {player: 'James', lock: true}, {player: 'Demonspeed', lock: true}, {player: 'Shad', lock: true}, {player: 'Maryxxi', lock: true}],
    }
  },
  {
    postId: 414,
    timestamp: '2022-07-22T23:16:00.000Z',
    players: {
      'Asako': [{player: 'Gnut', lock: false}, {player: 'Maryxxi', lock: false}],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [{player: 'Pom', lock: false}],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}, {player: 'Asako', lock: false}, {player: 'Anonymous vote', lock: true}, {player: 'Hermit', lock: true}, {player: 'Pom', lock: true}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}, {player: 'Tatsumaki', lock: false}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}, {player: 'SirSam', lock: false}, {player: 'James', lock: true}, {player: 'Demonspeed', lock: true}, {player: 'Shad', lock: true}, {player: 'Maryxxi', lock: true}],
    }
  },
  {
    postId: 418,
    timestamp: '2022-07-22T23:19:00.000Z',
    players: {
      'Asako': [{player: 'Gnut', lock: false}, {player: 'Maryxxi', lock: false}],
      'Maryxxi': [],
      'Digitaldude': [],
      'Demonspeed': [{player: 'James', lock: false}, {player: 'Hermit', lock: false}],
      'GB': [{player: 'Pom', lock: false}],
      'Gnut': [],
      'SirSam': [{player: 'Brandish', lock: false}, {player: 'Asako', lock: false}, {player: 'Anonymous vote', lock: true}, {player: 'Hermit', lock: true}, {player: 'Pom', lock: true}],
      'James': [],
      'Brandish': [],
      'Pom': [{player: 'GB', lock: false}, {player: 'GB', lock: true}, {player: 'Tatsumaki', lock: false}],
      'Shad': [],
      'Tatsumaki': [],
      'Gajeel': [],
      'Hermit': [{player: 'Demonspeed', lock: false}, {player: 'SirSam', lock: false}, {player: 'James', lock: true}, {player: 'Demonspeed', lock: true}, {player: 'Shad', lock: true}, {player: 'Maryxxi', lock: true}, {player: 'Brandish', lock: true}],
    }
  },
]
